import { parse } from '@babel/parser'

export function validateJsxSource (value) {
  const source = value || ''
  if (!source.trim()) {
    return []
  }

  try {
    parse(source, {
      sourceType: 'module',
      plugins: ['jsx']
    })
    return []
  } catch (error) {
    return [{
      row: (error?.loc?.line || 1) - 1,
      column: error?.loc?.column || 0,
      text: (error?.message || 'Invalid JSX syntax').replace(/\s*\(\d+:\d+\)\s*$/, ''),
      type: 'error'
    }]
  }
}

export async function formatJsxSource (value) {
  const source = value || ''
  if (!source.trim()) return source

  try {
    const [prettierModule, parserBabelModule] = await Promise.all([
      import('prettier/standalone.js'),
      import('prettier/parser-babel.js')
    ])
    const prettier = prettierModule.default || prettierModule
    const prettierParserBabel = parserBabelModule.default || parserBabelModule
    const prettierFormattedValue = prettier.format(source, {
      parser: 'babel',
      plugins: [prettierParserBabel],
      printWidth: 100,
      tabWidth: 2,
      singleQuote: true,
      semi: false
    })

    // Prettier may prepend a semicolon for ASI safety in JS files.
    // For our editor content, we only want whitespace/indent normalization.
    if (source.trimStart().startsWith(';')) {
      return prettierFormattedValue
    }
    return prettierFormattedValue.replace(/^(\s*);(?=\s*[<(])/u, '$1')
  } catch (error) {
    console.error('Failed to format JSX source', error)
    return source
  }
}
